export enum TrackEventTypeEnum {
  INCITATION_EMAIL_JOIN_PROGRAM_BUTTON_CLICKED = 'invitationEmailJoinProgramButtonClicked',
  INVITATION_EMAIL_JOIN_PROGRAM_QR_CODE_SCANNER = 'invitationEmailJoinProgramQrCodeScanned',
  INVITATION_EMAIL_DOWNLOAD_APP_BUTTON_CLICKED = 'invitationEmailDownloadAppButtonClicked',
  INVITATION_EMAIL_DOWNLOAD_APP_QR_CODE_SCANNER = 'invitationEmailDownloadAppQrCodeScanned',
  INVITATION_EMAIL_CONTACT_SUPPORT_CLICKED = 'invitationEmailContactSupportClicked',
}

export enum TrackEventCategoryEnum {
  INVITATION_EMAIL = 'invitationEmail',
}
